__webpack_require__.p = "https://protoselida.24media.gr/resources/client/2adc11f6ba5059c236c2/";